import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import SiteService from './SiteService';
import {
  IconButton, Menu, MenuItem,
  Table, TableHead, TableBody, TableRow, TableCell,
  Typography, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  Paper
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MainMeterSelector from './MainMeterSelector';

export default function SubMeterList() {
  const { mainMeterId: initialMainMeterId } = useParams();
  const [mainMeterId, setMainMeterId] = useState(initialMainMeterId);
  const [mainMeters, setMainMeters] = useState([]);
  const [subMeters, setSubMeters] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuSubMeterId, setMenuSubMeterId] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    SiteService.getMainMetersBySite().then(res => setMainMeters(res.data));
  }, []);

  useEffect(() => {
    if (mainMeterId) {
      SiteService.getSubMetersByMainMeter(mainMeterId).then(res => setSubMeters(res.data));
    }
  }, [mainMeterId]);

  const openMenu = (e, id) => {
    setAnchorEl(e.currentTarget);
    setMenuSubMeterId(id);
  };
  const closeMenu = () => {
    setAnchorEl(null);
  };
  const openDialog = () => {
    setDialogOpen(true);
    closeMenu();
  };
  const closeDialog = () => {
    setDialogOpen(false);
    setMenuSubMeterId(null);
  };

  const confirmDelete = () => {
    if (!menuSubMeterId) return;
    SiteService.deleteSubMeter(mainMeterId, menuSubMeterId)
      .then(() => {
        setSubMeters(prev => prev.filter(s => s.subMeterId !== menuSubMeterId));
        toast.success('Süzme sayaç başarıyla silindi!');
      })
      .catch(() => toast.error('Silme işlemi başarısız!'));
    closeDialog();
  };

  return (
    <Paper sx={{ p: 3 }}>
      <MainMeterSelector
        mainMeterId={mainMeterId}
        setMainMeterId={setMainMeterId}
      />

      <Typography variant="h5" align="center" gutterBottom>
        Süzme Sayaçlar
      </Typography>

      <Button
        variant="contained"
        component={Link}
        to={`/add-sub-meter/${mainMeterId}`}
        color="secondary"
        sx={{ mb: 2 }}
      >
        Süzme Sayaç Ekle
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Kod</TableCell>
            <TableCell>Adı</TableCell>
            <TableCell>Açıklama</TableCell>
            <TableCell>Öncelik</TableCell>
            <TableCell align="right">İşlemler</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {subMeters.map(s => (
            <TableRow key={s.subMeterId} hover>
              <TableCell>{s.kod}</TableCell>
              <TableCell>{s.name}</TableCell>
              <TableCell>{s.description}</TableCell>
              <TableCell>{s.priority}</TableCell>
              <TableCell align="right">
                <IconButton onClick={e => openMenu(e, s.subMeterId)}>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
        <MenuItem
          component={Link}
          to={menuSubMeterId ? `/update-sub-meter/${mainMeterId}/${menuSubMeterId}` : '#'}
          onClick={closeMenu}
        >
          Güncelle
        </MenuItem>
        <MenuItem onClick={openDialog}>
          Sil
        </MenuItem>
      </Menu>

      <Dialog open={dialogOpen} onClose={closeDialog}>
        <DialogTitle>Silme Onayı</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Bu alt sayacı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDialog}>İptal</Button>
          <Button color="error" variant="contained" onClick={confirmDelete}>
            Sil
          </Button>
        </DialogActions>
      </Dialog>

      <ToastContainer position="top-right" autoClose={2000} />
    </Paper>
  );
}
